<template>
    <div class="about-area about-style-4 rn-section-gap">
        <div class="container">
            <div class="row row--40 align-items-center">
                <div class="col-lg-6">
                    <Video :video-data="videoData" column="col-12"/>
                </div>
                <div class="col-lg-6 mt_md--40 mt_sm--40">
                    <div class="content">
                        <div class="inner">
                            <h3 class="title">
                                <strong style="color: black;">大连爱智控制系统有限公司</strong>
                                <p>原大连理工计算机控制工程有限公司</p>
                            </h3>
                            <ul class="feature-list">
                                <li>
                                    <Icon name="check" size="20" icon-class="icon"/>
                                    <div class="title-wrapper">
                                        <h4 class="title">深耕工业自动化领域</h4>
                                        <p class="text" style="font-family: Arial, Helvetica, sans-serif;">
                                            爱智控制成立于 2004 年 7 月，是以大连理工大学为依托的国家火炬计划重点高新技术企业
                                        </p>                                        
                                    </div>
                                </li>
                                <li>
                                    <Icon name="check" size="20" icon-class="icon"/>
                                    <div class="title-wrapper">
                                        <h4 class="title">推动国产PLC标准化系统建设</h4>
                                        <p class="text"><strong>参与制定国际标准 5 项，国家标准 6 项</strong></p>
                                        <p class="text" style="line-height:1.5;font-family: Arial, Helvetica, sans-serif;">
                                            自主研发MAC系列可编程控制系统、数控系统和机器人控制系统、PEC系列分布式控制系统，编程开发软件PLC_Config和监控管理组态开发软件DView等软硬件产品，并为用户提供自动化解决方案
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <div class="about-btn">
                                <router-link class="btn-default" to="/about-us">关于我们</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../../icon/Icon'
    import Video from "../video/Video";

    export default {
        name: 'AboutFour',
        components: {Video, Icon},
        props: {
            image: {}
        },
        data() {
            return {
                videoData: [
                    {
                        thumb: require(`@/assets/images/edge/Active/首页/服务介绍/homeBuilding.jpg`),
                         src: require('@/assets/video/01_普清480P.mp4'),
                    }
                ]
            }
        },
    }
</script>